import React from 'react'
import PropTypes from 'prop-types'
import { statusArr, getStatusBgClass } from 'AccountsUtils'
import { getMappedValue } from '../utils/arabicUtils'

const StatusBadge = ({ status, alias = null, extraClass = '', extraMar = null }) => (
  <p className={`${getStatusBgClass(status)} ${extraClass} fw-600 ${extraMar && 'mr-2'}`}>
    {alias || getMappedValue(status)}
  </p>
)
StatusBadge.defaultProps = {
  alias: null,
  extraClass: ''
}
StatusBadge.propTypes = {
  alias: PropTypes.string,
  status: PropTypes.oneOf(statusArr).isRequired,
  extraClass: PropTypes.string
}
export default StatusBadge
